<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-3 black--text">
                <span class="black--text txt-head"> 1. หลักการและเหตุผล </span>
                <span class="txt-normal" style="text-indent: 16px">
                  (ระบุที่มาและความสำคัญของการดำเนินโครงการแสดงรายละเอียดข้อมูลของปัญหาที่ผู้ประกอบการต้องการพัฒนา
                  และปรับปรุงประสิทธิภาพ
                  และผลลัพธ์ที่คาดว่าจะได้รับจากการนําเทคโนโลยี องค์ความรู้
                  และความช่วยเหลือของคณะผู้เชี่ยวชาญเข้าไปแก้ไขปัญหาและพัฒนากิจการ
                  เพิ่มประสิทธิภาพของกิจการของผู้ประกอบการ ชี้แจง
                  รายละเอียดโดยย่อ)
                </span>
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <Wysiwyg
                theme="3"
                :readonly="isOIC"
                height="250"
                :value="form.principle"
                @onChange="setFormField('principle', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">2. วัตถุประสงค์</span>
            <span class="txt-normal" style="text-indent: 16px">
              (ระบุข้อมูลที่ใช้วัดผลความสำเร็จเมื่อเสร็จโครงการ
              แสดงทั้งในรูปแบบของเชิงปริมาณและคุณภาพให้มีความสอดคล้องกับ
              วัตถุประสงค์ของโครงการ)
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <TextArea
            theme="3"
            height="100"
            :readonly="isOIC"
            :value="form.objective"
            @onChange="setFormField('objective', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">
              3. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <TextArea
            theme="3"
            :readonly="isOIC"
            height="100"
            :value="form.industry_group"
            @onChange="setFormField('industry_group', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">4. เป้าหมาย</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            height="250"
            :value="form.target"
            @onChange="setFormField('target', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"
              >5. โครงสร้างการบริหารอุทยานวิทยาศาสตร์</span
            >
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            height="250"
            :value="form.sci_park_mgm"
            @onChange="setFormField('sci_park_mgm', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            6. หน่วยงานเครือข่าย
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <TextArea
            theme="3"
            :readonly="isOIC"
            :value="form.coop_dep"
            @onChange="setFormField('coop_dep', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            7. ผลการดำเนินงานที่ผ่านมาในภาพรวม
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
        </div>

        <div>
          <div class="black--text mb-3">
            แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ภูมิภาค (Service Platform)
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            :value="form.perf_serv_plat"
            @onChange="setFormField('perf_serv_plat', $event)"
          ></Wysiwyg>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-3">
            แผนงานบ่มเพาะธุรกิจวิทยาศาสตร์เทคโนโลยีและนวัตกรรม (STI Business
            Incubation)
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            :value="form.perf_sti"
            @onChange="setFormField('perf_sti', $event)"
          ></Wysiwyg>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-3">
            แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่
            (IRTC)
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            :value="form.perf_irtc"
            @onChange="setFormField('perf_irtc', $event)"
          ></Wysiwyg>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="black--text mb-3">
            แผนงานวิจัยร่วมกับภาคเอกชน (Collaborative Research)
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            :value="form.perf_collab_resh"
            @onChange="setFormField('perf_collab_resh', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">
              8. สรุปโครงการที่ขอรับการสนับสนุน
            </span>
            <!--            <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>-->
          </div>
          <TextArea
            theme="3"
            height="100"
            :value="form.progress"
            @onChange="setFormField('progress', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import Wysiwyg from "../../../components/input/Wysiwyg.vue";

export default {
  name: "AFormProject",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    Wysiwyg,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    ...mapState({
      ProjectForm: (state) => state.AForm.ProjectForm,
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    if (this.isSameId && !this.masterData.form_a) this.form = this.ProjectForm;
    if (this.masterData.form_a) {
      if (this.masterData.form_a.form_ab_project_info) {
        this.form = this.masterData.form_a.form_ab_project_info;

        console.log("partTwoForm", this.form);
      }
    }
    eventBus.$on("aFormProject", () => {
      eventBus.$emit("aFormProjectSend", this.form);
    });
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped></style>
